import React, {useEffect, useState, ChangeEvent} from 'react'
import {measurementInitValues as initialValues} from '../../models/MeasurementModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Parameter} from '../parameter-list/core/_models'
import {AnimaFadeinTop} from '../../../../../../_metronic/assets/animation/styles'
import { Toolbar2 } from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import { PageTitle } from '../../../../../../_metronic/layout/core'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const measurementSchema = Yup.object().shape({
  //value: Yup.string().required('Campo obrigatório'),
})

const FormLogoEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const token = localStorage.getItem('auth_storage')
  const [oldImage, setOldImage] = useState('')
  const [selectedImage, setSelectedImage] = React.useState<File | null>(null)
  const timestamp = new Date().getTime()

  useEffect(() => {
    console.log('location', location)
    if (location) {
      const {parameter_option, uuid} = location.state as any
      if (parameter_option[0].value) {
        formik.setFieldValue('value', parameter_option[0].value)
        setOldImage(parameter_option[0].value)
      }
      formik.setFieldValue('uuid', uuid)
    }
    // eslint-disable-next-line
  }, [location])

  const [loading, setLoading] = useState(false)
  const datasend = new FormData() //formdata object

  const formik = useFormik<Parameter>({
    initialValues,
    validationSchema: measurementSchema,
    onSubmit: async (values) => {
      if (!selectedImage) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'COMMON.SELECT_IMAGE'}),
          showConfirmButton: false,
          timer: 1000,
        })
        return
      }
      setLoading(true)
      if (selectedImage) datasend.append('value', selectedImage)
      try {
        await axios({
          method: 'post',
          url: `${API_URL}/v1/parameters/update/${values.uuid}`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 1000,
        })
        setTimeout(() => {
          navigate('/parameters')
        }, 1000)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  const handleImageSelected = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setSelectedImage(file)
    }
  }

  return (
    <div className='card card-custom mt-n8'>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'PARAMETERS.LOGO_BLACK_EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <AnimaFadeinTop>
            <div className='card-body border-top p-9'>
              {/* INICIO INPUT ----------------------*/}
              <div className='mb-3 col-lg-12 d-flex'>
                <label htmlFor='image-upload' className='col-lg-2 col-form-label fw-bold required'>
                  {intl.formatMessage({id: 'COMMON.SELECT_IMAGE'})}
                </label>
                <input
                  name='value'
                  className='form-control form-control-sm'
                  type='file'
                  onChange={handleImageSelected}
                  required
                />
              </div>
              {/* FIM INPUT ----------------------*/}

              <div className='mb-3 col-lg-12 d-flex'>
                <div>
                  {selectedImage && (
                    <div className='col-lg-6'>
                      <div className='mt-6'>
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt='Imagem selecionada'
                          className='img-fluid  w-250px'
                        />
                      </div>
                      <label htmlFor='image-upload' className='form-label fs-6 fw-bold mx-20'>
                        {intl.formatMessage({id: 'PARAMETERS.LOGO_NEW'})}
                      </label>
                    </div>
                  )}
                  {oldImage && (
                    <div className='col-lg-6'>
                      <div className='mt-6'>
                        <img
                          src={oldImage + '?' + timestamp}
                          alt='Imagem selecionada'
                          className='img-fluid w-250px'
                        />
                      </div>
                      <label htmlFor='image-upload' className='form-label fs-6 fw-bold mx-20'>
                        {intl.formatMessage({id: 'PARAMETERS.LOGO_OLD'})}
                      </label>
                    </div>
                  )}
                </div>
              </div>


              {/* FIM INPUT ------------------------------*/}

              <div className='d-flex justify-content-end py-6'>
                <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                  {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                  {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
                </button>
              </div>
            </div>
          </AnimaFadeinTop>
        </form>
      </div>
    </div>
  )
}

export {FormLogoEdit}
